import React, { forwardRef } from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import SubmitButton from "./SubmitButton";
import { Button } from "@progress/kendo-react-buttons";
import { IoAlertCircleOutline } from "react-icons/io5";

export const CustomTitleBar = (title) => {
    return (
        <div
            style={{
                fontSize: "16px",
                lineHeight: "1.3em",
                color: "black",
                display: "flex",
                alignItems: "center",
            }}
        >
            <IoAlertCircleOutline className="me-2" size={20} />
            Confirmation
        </div>
    );
};

const ConfirmationDialog = forwardRef(
    (
        { title = "Please confirm", onClose, onClickYes, onClickNo, content, isLoading = false },
        ref
    ) => {
        return (
            <Dialog
                ref={ref}
                id="action_dialog"
                // height={180}
                title={<CustomTitleBar />}
                width={600}
                onClose={onClose}
            >
                <div className="w-100 d-flex flex-column align-items-center justify-content-center gap-1 p-3">
                    <p>
                        {content ? content : "Are you sure to remove file?"}
                    </p>
                    <div className="d-flex gap-2">
                        <Button
                            className="common-btn bgBtnSecondary"
                            onClick={onClickNo}
                            disabled={isLoading}
                        >
                            No
                        </Button>
                        <SubmitButton
                            onClick={onClickYes}
                            isLoading={isLoading}
                        >
                            Yes
                        </SubmitButton>
                    </div>
                </div>
            </Dialog>
        );
    }
);

export default ConfirmationDialog;
